import { createSlice } from "@reduxjs/toolkit"


const producttypeSlice = createSlice({
  name: "producttype",
  initialState: {


    producttype: null,
    producttypes: null,
    filteredProducttypes: null,
    filter: {
      search: null,
      pagination: null,

    },
    filterProducttypeCount: [
      10, 50, 100, 200, 300
    ],
    pagination: null,

    selectedProducttypes: [],

    selectedpagination: 0

  },
  reducers: {

    setProducttype(state, action) {
      state.producttype = action.payload
    },
    setProducttypes(state, action) {
      state.producttypes = action.payload
    }
    ,
    setFilteredItems(state, action) {
      state.filteredProducttypes = action.payload
    },
    resetProducttypes(state) {

      state.producttypes = null
      state.filteredProducttypes = null
      state.filter = {
        search: null,
        pagination: null,
      }

    }
    ,
    setFilter(state, action) {

      if (Array.isArray(action.payload)) {
        action.payload.map(item => {
          state.filter[item.key] = item.value
        })
      }
      else {
        state.filter[action.payload.key] = action.payload.value
      }


    },
    setPagination(state, action) {
      state.pagination = action.payload
    },

    removeProducttype(state, action) {

      state.producttypes = state.producttypes.filter(producttype => producttype.id !== action.payload)

      if (state.filteredProducttypes) {
        state.filteredProducttypes = state.filteredProducttypes.filter(producttype => producttype.id !== action.payload)
      }


    }
    ,
    updateProducttype(state, action) {

      action.payload.map(item => {
        state.producttype[item.key] = item.value
      })


    },

    updateProducttypes(state, action) {

      Object.keys(state.producttypes).forEach(key => {
        let item = state.producttypes[key]

        action.payload.ids.map(id => {

          if (item.id == id) {

            action.payload.changes.map(ch => {

              if (ch.value !== null) {
                state.producttypes[key][ch.key] = ch.value

              }
            })
          }
        })

      })

      if (state.filteredProducttypes) {

        Object.keys(state.filteredProducttypes).forEach(key => {
          let item = state.filteredProducttypes[key]

          action.payload.ids.map(id => {

            if (item.id == id) {

              action.payload.changes.map(ch => {

                if (ch.value !== null) {
                  state.filteredProducttypes[key][ch.key] = ch.value

                }
              })
            }
          })

        })


      }

    },

    addProducttype(state, action) {
      state.producttypes = [...state.producttypes, action.payload]
      state.filteredProducttypes = [...state.filteredProducttypes, action.payload]
    }
    ,
    onSelectProducttype(state, action) {
      if (action.payload.action === 'add') {
        state.selectedProducttypes = [...state.selectedProducttypes, action.payload.user]
      }
      if (action.payload.action === 'remove') {
        state.selectedProducttypes = state.selectedProducttypes.filter(user => user.id !== action.payload.user.id)
      }
    }

    ,

    setSelectedPagination(state, action) {
      state.selectedpagination = action.payload
    }

  },
});

export default producttypeSlice

export const producttypeActions = producttypeSlice.actions;